<template>
  <div class="flex flex-col justify-start">
    <div class="text-primary-500 font-bold mb-3">
      Shared With:
    </div>
    <div v-for="permission in permissions" :key="permission.id">
      <div>{{ permission.permissionGivenTo }}</div>
    </div>
  </div>
</template>
<script>
  import axios from 'axios';

  export default {

    props: {
      resource: {
        type: Object,
        default: () => {},
      },
    },
    data: () => ({
      permissions: [],
    }),

    mounted() {
      this.getPermissionsForResource();
    },

    methods: {
      async getPermissionsForResource() {
        const { data } = await axios.get(`/api/permissions/entity/${this.resource.id}/Document`);
        this.permissions = data;
      },
    },
  };
</script>